import { useWorkspaceIdentifiers } from "hooks/useWorkspace";
import { useProjectAuth } from "hooks/project/useProjectAuth";
import { useProjectIdentifiers } from "store/hooks/useProjectIdentifiers";

/** Where the current project's production base is changed, and whether this user can. */
export function useProductionBaseSettingsLink(): { settingsHref: string | null; canEdit: boolean } {
  const { workspaceId } = useWorkspaceIdentifiers();
  const { projectId } = useProjectIdentifiers();
  const { isViewer } = useProjectAuth(projectId);
  const settingsHref =
    workspaceId && projectId
      ? `/workspaces/${workspaceId}/projects/${projectId}/settings/general`
      : null;
  return { settingsHref, canEdit: !isViewer };
}
